module.exports = __webpack_public_path__ + "img/wenjuan.db2f3845.png";